<script lang="ts" setup>
import { computed } from 'vue';

import type { PriceRibbonMonth } from '@apps/main/new-desktop/modules/calendars';
import { MonthsSelectorInnerView } from '@apps/main/new-desktop/modules/calendars';

import { AppSvgIcon } from '@libs/ui';

interface CalendarTabProps {
  months: PriceRibbonMonth[];
  selectedMonthIsoDate: string;
  showHeader?: boolean;
}

const props = defineProps<CalendarTabProps>();

interface CalendarTabEmits {
  (eventName: 'confirm', newMonthSelectionDate: Date): void;
}

const emit = defineEmits<CalendarTabEmits>();

const extendedMonth = computed<PriceRibbonMonth | undefined>(() =>
  props.months.find((month) => month.isExtended)
);
</script>

<template>
  <div class="calendar-tab-wrapper">
    <div v-if="showHeader && extendedMonth" class="calendar-tab-header">
      <AppSvgIcon name="calendarOutlined" size="24" />
      <div class="calendar-tab-title">
        <span class="month-name">{{ extendedMonth.month }}</span>
        <span class="year-name">{{ extendedMonth.year }}</span>
      </div>
    </div>
    <MonthsSelectorInnerView
      :months="props.months"
      :selected-month-iso-date="props.selectedMonthIsoDate"
      @confirm="emit('confirm', $event)"
    />
  </div>
</template>

<style lang="scss" scoped>
.calendar-tab-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);
  .calendar-tab-header {
    display: flex;
    gap: var(--spacing-12);
    align-items: center;
    .calendar-tab-title {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-4);
      .month-name {
        @include font-label-m-bold;
      }
      .year-name {
        @include font-label-s-light;
      }
    }
  }
}
</style>
